import script from "./rec-history.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-history.vue?vue&type=script&lang=ts&setup=true"

import "./rec-history.vue?vue&type=style&index=0&id=649406bb&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649406bb"]])

export default __exports__